import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {TemplateModalComponent} from './index';

/**
 * Module for the template modal
 */
@NgModule({
  declarations: [TemplateModalComponent],
  entryComponents: [TemplateModalComponent],
  exports: [TemplateModalComponent],
  imports: [IonicModule],
  providers: [],
})
export class TemplateModalModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/template-modal/template-modal.module.ts